var exports = {
  "i": "xe533113f--aa2374--wrapper",
};

module.exports = exports;
